import { css } from 'styled-components';

const MenuTopWrapper = css`
  .legoMenuTopBar {
    position: static;
    background-color: ${({ theme }) => theme.colors.newKinedu};
  }
  .legoMenuContainer {
    position: absolute;
    background-color: ${({ theme }) => theme.colors.shadeLighter};
    height: calc(100% - 72px);

    .legoMenuNavList {
      height: auto;
      background-color: white;
      padding: 0 0 120px 0px;
    }
  }
  .legoMenuContent{
    overflow: auto;
  }
  .legoMenuContent.open{
    overflow: hidden;
  }
  .legoMenuContentBackdrop {
    background-color: rgba(0,0,0,0.40);
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    position: relative;
    .legoMenuContainer {
      top: 72px;
    }
    .legoMenuContent{
      top: 0px;
    }
  }
`;

export default MenuTopWrapper;
